import { render, staticRenderFns } from "./footerCss.vue?vue&type=template&id=5da8958a&scoped=true"
import script from "./footerCss.vue?vue&type=script&lang=js"
export * from "./footerCss.vue?vue&type=script&lang=js"
import style0 from "./footerCss.vue?vue&type=style&index=0&id=5da8958a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da8958a",
  null
  
)

export default component.exports